const SHOW_POINTS_KEY = "mapus.show-points";

export interface PrefStore {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

/** Graph vertices to paint. Hiding points omits the unselected ones. A point that is still selected stays drawn. */
export function markerIndices(count: number, selected: readonly number[], visible: boolean): number[] {
  const keep = new Set(selected.filter((index) => index >= 0 && index < count));
  const indices: number[] = [];
  for (let i = 0; i < count; i++) {
    if (visible || keep.has(i)) indices.push(i);
  }
  return indices;
}

/** Missing or any value other than "0" means the markers start visible. */
export function readShowPoints(store: PrefStore): boolean {
  try {
    return store.getItem(SHOW_POINTS_KEY) !== "0";
  } catch {
    return true;
  }
}

export function writeShowPoints(store: PrefStore, visible: boolean): void {
  try {
    store.setItem(SHOW_POINTS_KEY, visible ? "1" : "0");
  } catch {
    /* private mode or a full disk — the choice still applies this session */
  }
}
